import { Button } from '@mui/material';
import styled from 'styled-components';

export const Divisor = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;

  span {
    font-family: 'Quicksand', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: ${({ theme }) => theme.palette.grey._650.hex()};
    text-transform: uppercase;
  }

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background-color: ${({ theme }) => theme.palette.grey._400.hex()};
  }
`;

export const SeazoneButton = styled(Button)`
  && {
    height: 40px;
    width: 100%;
    border-radius: 10px;
    text-transform: none;
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 0px;
    color: ${({ theme }) => theme.palette.blue._950.hex()};
    border: 1px solid ${({ theme }) => theme.palette.blue._850.hex()};
    background-color: ${({ theme }) => theme.palette.white.main.hex()};
    transition: all 0.3s linear;

    &:hover {
      background-color: ${({ theme }) => theme.palette.white._250.hex()};
    }

    &:disabled {
      border-color: ${({ theme }) => theme.palette.grey._430.hex()};
      color: ${({ theme }) => theme.palette.grey._650.hex()};
    }
  }
`;

export const ErroDeLogin = styled.p`
  margin: 0;
  font-family: 'Quicksand', sans-serif;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  color: ${({ theme }) => theme.palette.red._600.hex()};
`;
